export const resetSelect = (ref) => {
  ref.classList.add('error-reg');

  setTimeout(() => {
    ref.classList.remove('error-reg');
  }, 5000);
};